module.exports = __webpack_public_path__ + "static/media/astronaut.c90cdfc0.svg";